import ApplicationForm from "@/components/ApplicationForm";
import { useSeo } from "@/hooks/useSeo";

const TRACKS = ["Veteran Apprentice", "Civilian Apprentice", "Experienced Trainer", "Volunteer Puppy Raiser", "Veteran Peer Mentor"];

export default function TrainerApplication() {
  useSeo("Master Dog Trainer Application", "Become a Master Dog Trainer with Golden Wolf Foundation. Apply as a veteran apprentice, civilian apprentice, experienced trainer, puppy raiser or peer mentor.");
  return (
    <ApplicationForm
      overline="Master Dog Trainer Program"
      title="Become a Trainer"
      sub="Choose your track and tell us your story. Veterans and civilians are both welcome."
      endpoint="/applications/trainer"
      consentLabel="I consent to a background check as part of the application process."
      fields={[
        { name: "name", label: "Full name", required: true, half: true },
        { name: "email", label: "Email", type: "email", required: true, half: true },
        { name: "phone", label: "Phone", type: "tel", half: true },
        { name: "track", label: "Which track?", type: "select", options: TRACKS, required: true, half: true },
        { name: "experience", label: "Relevant experience", type: "textarea" },
        { name: "career_goals", label: "Career goals", type: "textarea" },
        { name: "availability", label: "Availability", half: true },
        { name: "transportation", label: "Reliable transportation?", type: "select", options: ["Yes", "No"], half: true },
        { name: "physical_considerations", label: "Physical task considerations", type: "textarea" },
        { name: "dog_handling_history", label: "Dog-handling history", type: "textarea" },
        { name: "references", label: "References", type: "textarea", placeholder: "Name, relationship, contact" },
        { name: "training_interests", label: "Training interests", half: true },
        { name: "essay", label: "Essay: \"Why do you want to serve veterans through dogs?\"", type: "textarea", required: true },
      ]}
    />
  );
}
